import React, { useState, useEffect, useCallback, useRef } from 'react';
import { useDispatch } from 'react-redux';
import Icon from '../IconBase/Icon';
import { addOverlay, removeOverlay } from '../../Actions/Overlay.action';
import StackedPrices from './StackedPrices';
import { getTierPrices } from '../../Services/Cart.service';

const StackedPricesPopup = ({ articleNumber, onClosePopup }) => {
  const dispatch = useDispatch();
  const popupRef = useRef(null);
  const popupId = 'stacked-prices';
  const [marginBottom, setMarginBottom] = useState(0);
  const [marginLeft, setMarginLeft] = useState(0);
  const [tierPrices, setTierPrices] = useState([]);

  const resetPosition = () => {
    setMarginBottom(0);
    setMarginLeft(0);
  };
  const calcPosition = () => {
    if (popupRef.current !== null) {
      const rect = popupRef.current.getBoundingClientRect();
      const scrollBarWidth = window.innerWidth - document.body.clientWidth;
      const windowWidth = window.innerWidth - scrollBarWidth;
      const popupDiffLeft = windowWidth - rect.x - rect.width;
      setMarginBottom(rect.y < 0 ? rect.y : 0);
      setMarginLeft(popupDiffLeft < 0 ? popupDiffLeft : 0);
    }
  };

  const closePopup = useCallback(() => {
    resetPosition();
    dispatch(removeOverlay(popupId));
    onClosePopup();
    return true;
  }, []);

  useEffect(() => {
    calcPosition();
    dispatch(addOverlay(popupId, closePopup));
    handleTierPrices(articleNumber);
  }, []);

  useEffect(() => {
    calcPosition();
    dispatch(addOverlay(popupId, closePopup));
  }, []);

  useEffect(() => {
    const reCalcPosition = () => {
      resetPosition();
      calcPosition();
    };
    window.addEventListener('resize', reCalcPosition);
    return () => window.removeEventListener('resize', reCalcPosition);
  });

  const handleTierPrices = async (articleNumber) => {
    const response = await getTierPrices(articleNumber);
    setTierPrices(response);
  };

  return (
    <div
      className="stacked-prices-popup"
      ref={popupRef}
      style={{ marginLeft, marginBottom }}
    >
      <StackedPrices
        {...{
          articleNumber,
          tierPrices,
          closeButton: (
            <Icon
              onClick={closePopup}
              iconCode="close"
              className="stacked-prices-popup__close"
            />
          ),
        }}
      />
    </div>
  );
};

export default StackedPricesPopup;
